// extracted by mini-css-extract-plugin
export var container = "_iu-0";
export var dotAnimation = "_iu-2";
export var dotsLoading = "_iu-1";